<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="14" class='flex'>
        <el-select v-if="theUserProject == 0" v-model='theProjectId' @change="theProjectAllChange" size="small"
          clearable placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
        <el-select v-model='ouStatus' @change="statusChange" size="small">
          <el-option v-for="item in ouStatusAll || []" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model="getOpportunityList_data.customName" placeholder="请输入客户名称" clearable size='small'
          style="max-width:200px;" />
        <el-input v-model="getOpportunityList_data.userName" placeholder="请输入用户名" clearable size='small'
          style="max-width:200px;" />
        <el-button v-click.getOpportunityList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
        <!-- <el-button @click="toExport" type="primary" icon='el-icon-search' size='small' style='margin-left:10px;'>导出
        </el-button> -->
      </el-col>
      <el-col :span="8" class='flex'>
        <el-button type="primary" size='small' style='margin-left:10px;' @click="Out">导出
        </el-button>

      </el-col>
    </el-row>

    <mytable ref="getOpportunityListTable" :tableColums='tableColums_getOpportunityList' api='getOpportunityList::ouId'
      xupdateapi='updateOuMilestone' :height="H - 165">
    </mytable>

    <myform :viewobj='{
        addOuMilestone: ["新增商机信息", "el-icon-circle-plus"],
        updateOuMilestone: ["修改商机信息", "el-icon-edit-outline"],
        $succeed$: getOpportunityList
      }' @close='$form("addOuMilestone", "reset")'>
      <!-- <hide slot='ouId' /> -->
    </myform>
    <myform view.getOpportunityOne='里程碑记录' @opened="form => form.title += ' | @' + Myformdata.ouNum">
      <div v-if='Myformdata'>
        <div>订单编号 : {{ Myformdata.ouNum }}</div>
        <div>业务类型 : {{ Myformdata.btName }}</div>
        <div>里程碑 : </div>
        <div v-for="item in getOpportunityOne_data.data.ouMilestoneHistoryList" :key="item.mthId">
          {{ item.mtName + ' : ' + item.createtime }}
        </div>
      </div>
      <hide slot='ouId' />
    </myform>
    <myform :viewobj='{
        auditOpportunityAudit: ["确定要驳回吗?", "el-icon-circle-plus"],
        $succeed$: getOpportunityList
      }' @opened="myform => myform.title += ' | @' + Myformdata.ouNum"
      @close='$form("auditOpportunityAudit", "reset")'>
      <hide slot='ouId' />
      <template v-slot:ouAuditStatus="{ Myformdata }">
        <el-select v-model='Myformdata.ouAuditStatus' disabled>
          <el-option v-for="item in ouAuditStatusAll || []" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </template>
    </myform>
    <myform view.getOpportunityDetails='详情' @opened="form => form.title += ' | @' + row.ouNum">
      <div v-if='row'>
        <el-descriptions :column="1" border :labelStyle="{
        color: '#409EFF',
        textAlign: 'center',
        width: '20%',
        fontSize: '12px'
      }" :contentStyle="{ textAlign: 'left', width: '80%', fontSize: '12px' }">
          <el-descriptions-item label="订单编号">{{ row.ouNum }}</el-descriptions-item>
          <el-descriptions-item
            :contentStyle="{ textAlign: 'center', fontSize: '12px', display: 'flex', justifyContent: 'space-around' }"
            label="客户名称">
            {{ getOpportunityOne_data.data.customName }}
          </el-descriptions-item>
          <el-descriptions-item label="业务名称">{{ getOpportunityOne_data.data.opportunityBusiness.bcName
            }}</el-descriptions-item>
          <el-descriptions-item label="业务数量">{{ getOpportunityOne_data.data.opportunityBusiness.ouBusinessNum
            }}</el-descriptions-item>
          <el-descriptions-item label="业务年限">{{ getOpportunityOne_data.data.opportunityBusiness.obYear
            }}</el-descriptions-item>
          <el-descriptions-item label="签约金额">
            {{ getOpportunityOne_data.data.opportunityBusiness.obMoney }}</el-descriptions-item>
          <el-descriptions-item label="当月收入">
            {{ getOpportunityOne_data.data.opportunityBusiness.obMoneyMonth }}</el-descriptions-item>
          <el-descriptions-item label="年化金额">
            {{ getOpportunityOne_data.data.opportunityBusiness.obMoneyYear }}</el-descriptions-item>
          <el-descriptions-item label="创建人">{{ row.userName }}</el-descriptions-item>
          <el-descriptions-item label="订单描述">{{ row.ouRemark }}</el-descriptions-item>
          <el-descriptions-item label="计费时间">{{ row.ouStartTime }}</el-descriptions-item>
          <el-descriptions-item label="驳回理由">{{ getOpportunityOne_data.data.ouAuditRemark }}</el-descriptions-item>
        </el-descriptions>
        <el-table v-if="getOpportunityOne_data.data.opportunityAttrList" ref="kehuTable"
          :data="getOpportunityOne_data.data.opportunityAttrList" stripe border style="width: 100%" max-height="500px"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
        textAlign: 'center',
        background: 'rgba(0,170,255,0.5)',
        color: 'black',
        border: 'none'
      }">
          <el-table-column prop="qtName" label="题目名称" fixed="left">
          </el-table-column>
          <el-table-column prop="qttName" label="题目类型">
          </el-table-column>
          <el-table-column prop="qtOrder" label="排序" fixed="left">
          </el-table-column>
          <el-table-column prop="qtiValue" label="所选答案">
            <template slot-scope="scope">
              <img class="el-upload-list__item-thumbnail" :src="scope.row.qtiValue" alt=""
                style="width: 50px;height: 50px;" @click="PreviewVideo(scope.row.qtiValue)"
                v-if="scope.row.qttId == 3 && scope.row.qtiValue != '跳过'">
              <span v-if="scope.row.qttId == 3 && scope.row.qtiValue == '跳过'">{{ scope.row.qtiValue }}</span>
              <span v-if="scope.row.qttId != 3">{{ scope.row.qtiValue }}</span>
            </template>
          </el-table-column>

        </el-table>
        <div>法人身份证 :
          <el-image v-if="getOpportunityOne_data.data.opportunityImageListSfz" style="width: 100px; height: 100px"
            :src="getOpportunityOne_data.data.opportunityImageListSfz.oiPath" onclick="document.PreviewVideo(this.src)"
            :title="'点击预览 ' + getOpportunityOne_data.data.opportunityImageListSfz.oiPath" fit="cover">
          </el-image>
        </div>
        <div>营业执照 :
          <el-image v-if="getOpportunityOne_data.data.opportunityImageListYyzz" style="width: 100px; height: 100px"
            :src="getOpportunityOne_data.data.opportunityImageListYyzz.oiPath" onclick="document.PreviewVideo(this.src)"
            :title="'点击预览 ' + getOpportunityOne_data.data.opportunityImageListYyzz.oiPath" fit="cover">
          </el-image>
        </div>
        <div>签约合影 :
          <el-image v-if="getOpportunityOne_data.data.opportunityImageListQyhy" style="width: 100px; height: 100px"
            :src="getOpportunityOne_data.data.opportunityImageListQyhy.oiPath" onclick="document.PreviewVideo(this.src)"
            :title="'点击预览 ' + getOpportunityOne_data.data.opportunityImageListQyhy.oiPath" fit="cover">
          </el-image>
        </div>
        <div>合同照片 :
          <div v-if="getOpportunityOne_data.data.opportunityImageListHtString">
            <el-image v-for="item in getOpportunityOne_data.data.opportunityImageListHtString" :key="item"
              style="width: 100px; height: 100px" :src="item" onclick="document.PreviewVideo(this.src)"
              :title="'点击预览 ' + item" fit="cover">
            </el-image>
          </div>
        </div>
        <div>系统内截图 :
          <el-image v-if="getOpportunityOne_data.data.opportunityImageListXtnjt" style="width: 100px; height: 100px"
            :src="getOpportunityOne_data.data.opportunityImageListXtnjt.oiPath"
            onclick="document.PreviewVideo(this.src)"
            :title="'点击预览 ' + getOpportunityOne_data.data.opportunityImageListXtnjt.oiPath" fit="cover">
          </el-image>
        </div>
      </div>
      <hide slot='ouId' />
    </myform>

    <el-dialog title="关联订单" :visible.sync="IsVia" width="50%" :before-close="IsViaClose">
      <el-table :data="getAuditArr" stripe border style="width: 100%" max-height="500px"
        :cell-style="{ textAlign: 'center' }" :header-cell-style="{
        textAlign: 'center',
        background: 'rgba(0,170,255,0.5)',
        color: 'black',
        border: 'none'
      }">
        <el-table-column prop="ouBusinessName" label="业务"> </el-table-column>
        <el-table-column prop="userName" label="创建人"> </el-table-column>
        <el-table-column prop="customName" label="客户"> </el-table-column>
        <el-table-column prop="mtName" label="里程碑">
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间"> </el-table-column>
        <el-table-column prop="ouStartTime" label="启动时间">
        </el-table-column>
        <el-table-column prop="ouRemark" label="描述"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text"
              @click='$form("getOpportunityDetails", $this.row = scope.row), getOpportunityOne({ ouId: scope.row.ouId });'>详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsViaClose()">取 消</el-button>
        <el-button type="primary" @click="submitVia()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导出-是否带出图片" :visible.sync="isBulk" width="30%" :before-close="BulkClose"
      style="margin-left: 160px;">

      <el-radio-group v-model="imgType" style="display:block;text-align: center;">
        <el-radio-button :label="2">是</el-radio-button>
        <el-radio-button :label="1">否</el-radio-button>

      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BulkClose">取 消</el-button>
        <el-button type="primary" @click="Bulksure">确 定</el-button>
      </span>
    </el-dialog>
    <myform :viewobj='{
        updateOpportunityOrder: ["修改订单信息", "el-icon-edit-outline"],
        $succeed$: getOpportunityList
      }' @close='$form("updateOpportunityOrder", "reset")' @confirm='myform'>
      <template v-slot:customId="{ Myformdata }">

      </template>

      <template v-slot:ouStartTime="{ Myformdata }">
        <el-date-picker v-model="Myformdata.ouStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间">
        </el-date-picker>

      </template>
      <template v-slot:opportunityImageList="{ Myformdata }">
        <div v-for="(item, index) in imageList || []" :key="index">
          <el-form-item :label="item.name" label-width="100" v-if="item.oiType">
            <my-upload ref="Imgupload" @fileChange="fileChange($event, index)" :filearr="item.fileList" :limit="limit"
              @removeAfter="removeAfter($event, index)" style="margin: 10px 5px 5px;">
            </my-upload>
          </el-form-item>
        </div>
      </template>
      <template v-slot:bcId="{ Myformdata }">
        <el-select v-model='Myformdata.bcId' clearable @change="propertyChanges">
          <el-option v-for="item in getBusinessClassList_data.data || []" :key="item.bcId" :label="item.bcName"
            :value="item.bcId">
          </el-option>
        </el-select>
      </template>
      <hide slot='ouId' />
      <!-- <hide slot='yuvcName' />
      <hide slot='yuvbName' />
      <hide slot='yuvpName' /> -->
      <!-- <hide slot='bcId' /> -->
      <hide slot='bcName' />
      <hide slot='ouBusinessName' />
      <hide slot='bcNameOther' />
    </myform>


  </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      formDetail: {},
      formBuilding: {},
      DiyList: [],
      fileList: [],
      limit: 6,
      imageList: [{
        oiType: 1,
        oiPath: '',
        fileList: [],
        name: '法人身份证',
        oinum: '1'
      },
      {
        oiType: 2,
        oiPath: '',
        fileList: [],
        name: '营业执照',
        oinum: '2'
      },
      {
        oiType: 4,
        oiPath: '',
        fileList: [],
        name: '签约合影',
        oinum: '3'
      },
      {
        oiType: 3,
        oiPath: '',
        fileList: [],
        name: '合同照片',
        oinum: '4'
      },
      {
        oiType: 5,
        oiPath: [],
        name: '系统内截图',
        fileList: [],
        oinum: '5'
      },
      ],
      formOu: {
        ouNumVip: '',
        obMoneyMonth: '',
        yuvbId: '',
        yuvbcId: '',
        yuvbcName: '',
        yuvbName: '',
        yuvbFloor: '',
        yuvbAddress: '',
        ouGroupNum: '',
        yuvpId: '',
        yuvpName: '',
        yuvpNetworkNum: '',
        yuvpNetworkMoney: '',
        yuvpFixedlineOperator: '',
        yuvpFixedlineNum: '',
        yuvpFixedlineExpirationDate: '',
        yuvpFixedlineMoney: '',
        yuvpTotalMoney: '',
        userVisitorKeyuserProperty: '',
        userVisitorNetworkProperty: '',

        hasUserUpdateBuilding: null,
        hasUserUpdateCompany: null,
        hasUserUpdateProperty: null,


        ouContractScene: '',
        bcNameOther: '',
        ouId: '',
        bcName: '',
        bcId: '',
        ouMoney: '',
        ouBusinessNum: '',
        obYear: '',
        obMoneyYear: '',
        ouContractType: '',
        ouContractTypeName: '',
        ouTypeName: '',
        ouType: '',
        yuvcName: '',
        customId: '',
        ouStartTime: '',
        yewunamestr: '',
        ouRemark: '',
        opportunityImageList: '',
        opportunityBusinessListString: '',
        userVisitorKeyuserCompany: '',
        userVisitorNetworkCompany: '',
        yuvcNetworkNum: '',
        yuvcNetworkMoney: '',
        yuvcFixedlineOperator: '',
        yuvcFixedlineNum: '',
        yuvcFixedlineExpirationDate: '',
        yuvcFixedlineMoney: '',
        yuvcTotalMoney: '',
      },
     
      imgType: 1,
      isBulk: false,
      command: null,
      companyFold: false,
      IsVia: false,
      getAuditArr: [],
      ouId: null,
      baseUrl: $Api.baseUrl_online,
      theProjectId: "",
      theUserProject: "",
      ouStatus: 2,
      ouStatusAll: [{
        id: 2,
        name: '待审核'
      },
      {
        id: 4,
        name: '审核驳回'
      },
      ],
      ouAuditStatus: 1,
      ouAuditStatusAll: [{
        id: 1,
        name: '通过'
      },
      {
        id: 2,
        name: '驳回'
      },
      ],
      tableColums_auditOpportunityAuditRepeat: {
        $selection: false,

        // ouNum: '编号',

        bcName: '业务',

        userName: '创建人',

        customName: '客户',

        createtime: '创建时间',

        ouStartTime: '启动时间',

        ouRemark: '描述',


      },
      tableColums_getOpportunityList: {
        $selection: true,

        // ouNum: '编号',

        ouBusinessNames: '业务',
        dtName: '分公司',
        userName: '创建人',

        customName: '客户',

        createtime: '创建时间',

        ouStartTime: '启动时间',

        ouRemark: '描述',

        ouAuditRemark: '驳回理由',

        $operation: [
          '操作', 260,
          // this.updateOpportunityOrder && `@text: 编辑#success
          //  @click:  handelEdit($row)
          // `,
          this.getOpportunityOne && `@text: 详情#success
           @click: $form("getOpportunityDetails",$this.row = $row),getOpportunityOne({ouId:$row.ouId})
          `,
          this.auditOpportunityAudit && `@text: 通过审核#success
           @v-if: ouStatus == 2
           @click: ViaAudit($row)
          `,
          this.auditOpportunityAudit && `@text: 驳回审核#danger
           @v-if: ouStatus == 2
           @click: row = $row, $row.ouAuditStatus = 2, $form("auditOpportunityAudit", $row )
          `,
        ],

      },

    };
    // _confirm('确定要通过吗?')
    //         .trigger('auditOpportunityAudit',{ouId:$row.ouId,ouAuditStatus:1,ouAuditRemark:'通过'})
    //         .trigger('getOpportunityList')
  },

  watch: {

  },

  methods: {
    PreviewVideo(url) {
      document.PreviewVideo(url)
    },
    removeAfter(file, index) {
      const url = this.imageList[index].oiPath.findIndex(item => item === file)
      this.imageList[index].oiPath.splice(url, 1);
      console.log(this.imageList);
    },
    fileChange(file, indexs) {
      console.log(file, indexs);
      this.imageList[indexs].oiPath = file.toString();
      file.forEach((item, index) => {
        console.log(item);
        this.imageList[indexs].fileList.push({ name: item, url: item })
        console.log(this.imageList[indexs].fileList);
      })

      console.log(this.imageList);
      this.$message({
        type: "success",
        message: "上传成功!",
      });

    },
    async handelEdit(row) {
      this.imageList = [{
        oiType: 1,
        oiPath: [],
        name: '法人身份证',
        fileList: [],
        oinum: '1'
      },
      {
        oiType: 2,
        oiPath: [],
        name: '营业执照',
        fileList: [],
        oinum: '2'
      },
      {
        oiType: 4,
        oiPath: [],
        name: '签约合影',
        fileList: [],
        oinum: '3'
      },
      {
        oiType: 3,
        oiPath: [],
        name: '合同照片',
        fileList: [],
        oinum: '4'
      },
      {
        oiType: 5,
        oiPath: [],
        name: '系统内截图',
        fileList: [],
        oinum: '5'
      },
      ];
      this.getOpportunityOne({ ouId: row.ouId }).result((res) => {
        console.log(res);
        if (res.data.data) {
          const obj = res.data.data;
          for (let formkey in this.formOu) {
            for (let key in obj) {
              if (formkey == key) {
                // console.log(key);
                this.formOu[key] = obj[key]
              }
            }
            for (let key in obj.opportunityBusiness) {
              if (formkey == key) {
                // console.log(key);
                this.formOu[key] = obj.opportunityBusiness[key]
              }
            }
          }
          this.imageList.forEach((value, index) => {
            if (value.oiType == 1) {
              value.oiPath = obj.opportunityImageListSfz ? obj.opportunityImageListSfz.oiPath : []
              const img = {
                name: obj.opportunityImageListSfz ? obj.opportunityImageListSfz.oiPath : '',
                url: obj.opportunityImageListSfz ? obj.opportunityImageListSfz.oiPath : '',
              }
              value.fileList = obj.opportunityImageListSfz ? [img] : []
            } else if (value.oiType == 2) {
              value.oiPath = obj.opportunityImageListYyzz ? obj.opportunityImageListYyzz.oiPath : []
              const img = {
                name: obj.opportunityImageListYyzz ? obj.opportunityImageListYyzz.oiPath : '',
                url: obj.opportunityImageListYyzz ? obj.opportunityImageListYyzz.oiPath : '',
              }
              value.fileList = obj.opportunityImageListYyzz ? [img] : []
            } else if (value.oiType == 4) {
              value.oiPath = obj.opportunityImageListQyhy ? obj.opportunityImageListQyhy.oiPath : []
              const img = {
                name: obj.opportunityImageListQyhy ? obj.opportunityImageListQyhy.oiPath : '',
                url: obj.opportunityImageListQyhy ? obj.opportunityImageListQyhy.oiPath : '',
              }
              value.fileList = obj.opportunityImageListQyhy ? [img] : []
            } else if (value.oiType == 5) {
              value.oiPath = obj.opportunityImageListXtnjt ? obj.opportunityImageListXtnjt.oiPath : []
              const img = {
                name: obj.opportunityImageListXtnjt ? obj.opportunityImageListXtnjt.oiPath : '',
                url: obj.opportunityImageListXtnjt ? obj.opportunityImageListXtnjt.oiPath : '',
              }
              value.fileList = obj.opportunityImageListXtnjt ? [img] : []
            } else {
              value.oiPath = obj.opportunityImageListHt || []
              if (obj.opportunityImageListHt && obj.opportunityImageListHt.length > 0) {
                const imgurl = []
                obj.opportunityImageListHt.forEach((item, indexs) => {
                  const img = {
                    name: item,
                    url: item,
                  }
                  imgurl.push(img)

                })
                this.$set(this.imageList[index], 'fileList', imgurl)
                console.log(value.fileList);
              } else {
                value.fileList = []
              }
            }

          })


        }
        this.$nextTick(() => {
          this.$form("updateOpportunityOrder", this.formOu);
        })
      });
    },
    sub(submit) {
      const list = this.imageList
      for (let key in this.formBuilding) {
        this.Myformdata[key] = this.formBuilding[key];
        this.formBuilding[key] = '';
      };
      this.Myformdata.opportunityImageList = JSON.stringify(list);
      console.log(this.Myformdata);

      this.imageList = [{
        oiType: 1,
        oiPath: [],
        name: '法人身份证',
        fileList: [],
        oinum: '1'
      },
      {
        oiType: 2,
        oiPath: [],
        name: '营业执照',
        fileList: [],
        oinum: '2'
      },
      {
        oiType: 4,
        oiPath: [],
        name: '签约合影',
        fileList: [],
        oinum: '3'
      },
      {
        oiType: 3,
        oiPath: [],
        name: '合同照片',
        fileList: [],
        oinum: '4'
      },
      {
        oiType: 5,
        oiPath: [],
        name: '系统内截图',
        fileList: [],
        oinum: '5'
      },
      ];
      submit();

    },
    async myform(submit, Myformdata) {
      console.log('112');
      this.imageList.forEach((item, index) => {
        if (item.oiType == 3 && item.oiPath.length == 0) {

          console.log('11', item.oiPath.length);
          item.oiPath = ''

        } else if (item.oiType == 3 && item.oiPath.length > 0) {
          item.fileList.forEach((img, imgIndex) => {
            const s = {
              oiType: 3,
              oiPath: img.url,
              name: '合同照片',
              oinum: '4'
            }
            this.imageList.push(s)
          })

        }
        if (item.oiType != 3 && item.oiPath.length == 0) {
          console.log('22', item.oiPath.length);
          item.oiPath = ''
        }
      })
      this.imageList.splice(3, 1)

      console.log(this.imageList);
      this.sub(submit)
    },



    theDtChange(e) {
      this.theDtId = e;
      this.$refs.cascader.dropDownVisible = false;
      this.getOpportunityList({
        currentPage: 1,
        ouStatus: this.ouStatus,
        dtId: this.theDtId,
        projectId: this.theProjectId,
        customName: this.getOpportunityList_data.customName,
        userName: this.getOpportunityList_data.userName,
      });
    },
    Bulksure() {
      var that = this
      const selection = Object.keys(this.$refs.getOpportunityListTable.$MyTableCache);
      console.log(selection.join());
      const bulkdata = {
        ouStatus: that.ouStatus,
        projectId: that.theProjectId,
        customName: that.getOpportunityList_data.customName,
        userName: that.getOpportunityList_data.userName,
        exportType: 2,
        hasImage: that.imgType,
        ouIds: selection.join() || ''
      }
      this.openLoading();
      var s = qs.stringify(bulkdata);

      axios({
        method: 'post',
        url: that.baseUrl + '/opportunity/ou/exportOpportunityListOrder',
        data: s,
        withCredentials: true,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'token': A.local('$Usertoken'),
          'projectId': +A.local('$projectId'),
        }
      }).then(function (res) {
        if (res.data) {
          that.loading.close();
          let a = document.createElement('a');
          //ArrayBuffer 转为 Blob
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel"
          });
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", '订单.xlsx');
          a.click();
          that.$message({
            message: "成功",
            type: "success"
          });
          that.BulkClose()

        }
      })
    },
    BulkClose() {
      this.isBulk = false;

    },
    Out(e) {
      this.isBulk = true;
    },

    IsViaClose() {
      this.IsVia = false
    },
    submitVia() {
      this.$confirm('是否确认审核通过, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.auditOpportunityAudit({
          ouId: this.ouId,
          ouAuditStatus: 1,
          ouAuditRemark: '通过'
        }).result(res => {
          this.IsVia = false;
          this.getOpportunityList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    async ViaAudit(val) {
      this.ouId = val.ouId
      await this.auditOpportunityAuditRepeat({
        ouId: val.ouId
      }).result(res => {
        if (res.data.data.length > 0) {
          console.log()
          this.getAuditArr = res.data.data;
          this.IsVia = true
          console.log(res.data.data)

        } else {
          this.$confirm('是否确认审核通过, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.auditOpportunityAudit({
              ouId: val.ouId,
              ouAuditStatus: 1,
              ouAuditRemark: '通过'
            }).result(res => {
              this.getOpportunityList()
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        }
      })
    },
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    toExport: async function () {
      const that = this;
      var postData = {
        ouStatus: that.ouStatus,
        projectId: that.theProjectId,
        customName: that.getOpportunityList_data.customName,
        userName: that.getOpportunityList_data.userName,
      };
      var s = qs.stringify(postData);
      that.openLoading();
      axios({
        method: 'post',
        url: that.baseUrl + '/opportunity/ou/exportOpportunityListOrder',
        data: s,
        withCredentials: true,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'token': A.local('$Usertoken'),
          'projectId': +A.local('$projectId'),
        }
      }).then(function (response) {
        that.loading.close();
        let a = document.createElement('a');
        //ArrayBuffer 转为 Blob
        let blob = new Blob([response.data], {
          type: "application/vnd.ms-excel"
        });
        let objectUrl = URL.createObjectURL(blob);
        a.setAttribute("href", objectUrl);
        var name = "待审核订单";
        if (that.ouStatus == 4) {
          name = "审核驳回订单";
        }
        a.setAttribute("download", name + '.xlsx');
        a.click();
        that.$message({
          message: "成功",
          type: "success"
        });
      }).catch(function (error) {
        that.loading.close();
        console.log(error);
      });
    },
    statusChange(e) {
      this.ouStatus = e;
      this.getOpportunityList({
        projectId: this.theProjectId,
        ouStatus: this.ouStatus
      });
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.getOpportunityList({
        projectId: this.theProjectId,
        ouStatus: this.ouStatus
      });
    },
  },

  created() {
    this.theUserProject = A.local('$projectId');
    if (this.theUserProject == 0) {
      this.getProjectList({
        pageSize: 0
      });
    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getOpportunityList({
      projectId: this.theProjectId,
      ouStatus: this.ouStatus
    });
    this.getBusinessClassList({ projectId: A.local('$projectId'), pageSize: 0 })
  },
  mounted() {

  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/bussiness/ExamineManage.vue